import { createBrowserRouter, Navigate } from "react-router-dom";
import * as LINKS from "./links";

// Layouts
import AppLayout from "../layouts/AppLayout";
import SettingsLayout from "../layouts/SettingsLayout";
import CheckoutLayout from "../layouts/CheckoutLayout";
import MarketingLayout from "../layouts/MarketingLayout";

// Pages
import LandingPage from "../pages/LandingPage";
import NewLandingPage from "../pages/NewLandingPage";
import ToolSpecPage from "../pages/newLanding/ToolSpecPage";
import Pricing from "../pages/Pricing";
import PrivacyPolicy from "../pages/PrivacyPolicy";
import TermsOfService from "../pages/TermsOfService";
import Sitemap from "../pages/Sitemap";
import ErrorBoundaryApp from "../pages/ErrorBoundaryApp";

// Authentication pages
import Login from "../pages/auth/Login";
import Logout from "../pages/auth/Logout";
import ResetPassword from "../pages/auth/ResetPassword";
import Signup from "../pages/auth/Signup";

// Settings pages
import Billing from "../pages/settings/Billing";
import CheckoutReturn from "../pages/settings/CheckoutReturn";
import Settings from "../pages/settings/Settings";
import Styles from "../pages/settings/Templates";
import Subscription from "../pages/settings/Subscription";
import ChangePassword from "../pages/settings/ChangePassword";
import LanguageCompletion from "../pages/settings/LanguageCompletion";

// Tool pages
import CommunicationGenerator from "../pages/tools/CommunicationGenerator";
import LessonLab from "../pages/tools/LessonLab";
import Researcher from "../pages/tools/Researcher";
import ResourceCustomiser from "../pages/tools/ResourceCustomiser";

// Components
import Invoices from "../components/Invoices";
import EmailVerification from "../components/EmailVerification";
import CatchupCoach from "@/pages/tools/CatchupCoach";

export const router = createBrowserRouter(
  [
    {
      id: "authenticate",
      path: LINKS.AUTHENTICATE,
      ErrorBoundary: ErrorBoundaryApp,
      element: <Login />,
    },
    {
      id: "authenticate/reset-password",
      path: LINKS.AUTHENTICATE_RESET_PASSWORD,
      ErrorBoundary: ErrorBoundaryApp,
      element: <ResetPassword />,
    },
    {
      id: "authenticate/signup",
      path: LINKS.AUTHENTICATE_SIGNUP,
      ErrorBoundary: ErrorBoundaryApp,
      element: <Signup />,
    },
    {
      id: "marketing",
      ErrorBoundary: ErrorBoundaryApp,
      Component: MarketingLayout,
      children: [
        {
          id: "welcome",
          path: LINKS.WELCOME,
          element: <NewLandingPage />,
        },
        {
          id: "new-landing-tool-spec",
          path: "/welcome/:toolSlug",
          element: <ToolSpecPage />,
        },
      ],
    },
    {
      id: "base",
      ErrorBoundary: ErrorBoundaryApp,
      Component: AppLayout,
      children: [
        {
          id: "root",
          index: true,
          element: <LandingPage />,
        },

        {
          id: "pricing",
          path: "/pricing",
          element: <Pricing />,
        },
        {
          id: "writing-wizard",
          path: LINKS.WRITING_WIZARD,
          element: <CommunicationGenerator />,
        },
        {
          id: "lesson-lab",
          path: LINKS.LESSON_LAB,
          element: <LessonLab />,
        },
        {
          id: "professor",
          path: LINKS.RESEARCHER,
          element: <Researcher />,
        },
        {
          id: "resource-refinery",
          path: LINKS.RESOURCE_REFINERY,
          element: <ResourceCustomiser />,
        },
        // Legacy redirects
        {
          id: "communications-generator-redirect",
          path: LINKS.COMMUNICATIONS_GENERATOR,
          element: <Navigate to={LINKS.WRITING_WIZARD} replace />,
        },
        {
          id: "resource-customiser-redirect",
          path: LINKS.RESOURCE_CUSTOMISER,
          element: <Navigate to={LINKS.RESOURCE_REFINERY} replace />,
        },
        {
          id: "catchup-coach",
          path: LINKS.CATCHUP_COACH,
          element: <CatchupCoach />,
        },
        {
          id: "reset-password",
          path: LINKS.RESET_PASSWORD,
          element: <ResetPassword />,
        },
        {
          id: "privacy-policy",
          path: LINKS.PRIVACY_POLICY,
          element: <PrivacyPolicy />,
        },
        {
          id: "terms-of-service",
          path: LINKS.TERMS_OF_SERVICE,
          element: <TermsOfService />,
        },
        {
          id: "sitemap",
          path: LINKS.SITEMAP,
          element: <Sitemap />,
        },
        {
          id: "settings",
          path: LINKS.SETTINGS,
          Component: SettingsLayout,
          children: [
            {
              id: "general",
              index: true,
              element: <Settings />,
            },
            {
              id: "templates",
              path: LINKS.SETTINGS_TEMPLATES,
              element: <Styles />,
            },
            {
              id: "subscription",
              path: LINKS.SETTINGS_SUBSCRIPTION,
              element: <Subscription />,
            },
            {
              id: "invoices",
              path: LINKS.SETTINGS_INVOICES,
              element: <Invoices />,
            },
            {
              id: "change-password",
              path: LINKS.SETTINGS_CHANGE_PASSWORD,
              element: <ChangePassword />,
            },
            ...(import.meta.env.DEV
              ? [
                  {
                    id: "language-completion",
                    path: LINKS.SETTINGS_LANGUAGE_COMPLETION,
                    element: <LanguageCompletion />,
                  },
                ]
              : []),
          ],
        },
        {
          id: "logout",
          path: LINKS.LOGOUT,
          element: <Logout />,
        },
        {
          id: "verify-email",
          path: LINKS.VERIFY,
          element: <EmailVerification />,
        },
      ],
    },
    {
      id: "checkout",
      path: LINKS.CHECKOUT,
      ErrorBoundary: ErrorBoundaryApp,
      Component: CheckoutLayout,
      children: [
        {
          id: "checkout-main",
          index: true,
          element: <Billing />,
        },
        {
          id: "checkout-return",
          path: LINKS.CHECKOUT_RETURN,
          element: <CheckoutReturn />,
        },
      ],
    },
  ],
  {}
);
